import { inject, Injectable } from '@angular/core';
import { QarepaIntermediate } from '@qarepa/common';
import { BehaviorSubject, shareReplay } from 'rxjs';
import { Bank } from '../types/bank';
import { BankApiObject } from '../types/bank.response';
import { BankHttpService } from './bank-http.service';

@Injectable({
  providedIn: 'root',
})
export class BankService extends QarepaIntermediate {
  private readonly banksSubject = new BehaviorSubject<Bank[]>([]);

  private http = inject(BankHttpService);

  get banks$() {
    return this.banksSubject.asObservable().pipe(shareReplay(1));
  }

  public banks(): void {
    if (!(this.isAuth && this.storage.get())) {
      return;
    }

    this.http.banks$().subscribe({
      next: this.nextBanks,
      error: this.errorBanks,
    });
  }

  private nextBanks = (response: BankApiObject): void => {
    const banks = response.result;
    this.banksSubject.next(banks);
  };

  private errorBanks = (): void => {
    this.banksSubject.next([]);
  };
}
